import { QuestApplet } from 'models/QuestApplet';
import { QuestDropdownItem } from './QuestDropdownItem';
import { useSelector } from 'react-redux';
import { selectGroupedApplets } from 'modules/applets/selectors';
import { sortModeSelect } from 'modules/profile/selectors';

export type GroupedApplets = {
  header: string;
  items: QuestApplet[];
};

export type QuestSectionItemsProps = {
  onAppletClick: (applet: QuestApplet) => void;
  previewHeight?: string;
  previewWidth?: string;
};

export const QuestSectionItems = ({
  onAppletClick,
  previewHeight = '139px',
  previewWidth = '146px',
}: QuestSectionItemsProps) => {
  const groupedApplets = useSelector(selectGroupedApplets);
  const sortMode = useSelector(sortModeSelect);

  return (
    <>
      {groupedApplets?.map(({ header, items }, idx) => (
        <QuestDropdownItem
          key={`${sortMode}-${header}-${idx}`}
          item={{ title: header, applets: items }}
          onAppletClick={onAppletClick}
          previewHeight={previewHeight}
          previewWidth={previewWidth}
        />
      ))}
    </>
  );
};
